import React, { useContext, useState, useEffect } from 'react';
import ScopeContext from '../../contexts/ScopeContext';
import AuthContext from '../../contexts/AuthContext';
import { FaUserPlus } from 'react-icons/fa';

const getDismissedKey = (userId, groupId) => `groupInviteBannerDismissed:${userId}:${groupId}`;

const GroupInviteBanner = () => {
    const { isGroupScope, currentScope, scopeMembers } = useContext(ScopeContext);
    const { user } = useContext(AuthContext);
    const [copySuccess, setCopySuccess] = useState(false);

    const group = currentScope?.group;
    const groupId = group?.id;

    const [isDismissed, setIsDismissed] = useState(() => {
        if (!user?.id || !groupId) return false;
        return localStorage.getItem(getDismissedKey(user.id, groupId)) === 'true';
    });

    // Reset dismissed state when group changes
    useEffect(() => {
        if (!user?.id || !groupId) {
            setIsDismissed(false);
            return;
        }
        setIsDismissed(localStorage.getItem(getDismissedKey(user.id, groupId)) === 'true');
    }, [user?.id, groupId]);

    // Listen for logout to reset state
    useEffect(() => {
        const handleLogout = () => {
            setCopySuccess(false);
        };
        window.addEventListener('auth:logout', handleLogout);
        return () => window.removeEventListener('auth:logout', handleLogout);
    }, []);

    const handleDismiss = () => {
        if (user?.id && groupId) {
            localStorage.setItem(getDismissedKey(user.id, groupId), 'true');
        }
        setIsDismissed(true);
    };

    const copyToClipboard = () => {
        if (group?.invite_code) {
            navigator.clipboard.writeText(group.invite_code);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        }
    };

    // Don't show if:
    // - No user logged in
    // - Not in a group scope
    // - No group data
    // - More than one member in the group
    // - Already dismissed for this user+group
    if (!user?.id || !isGroupScope || !group || scopeMembers.length > 1 || isDismissed) {
        return null;
    }

    return (
        <div className="group-invite-banner">
            <div className="group-invite-header">
                <span className="group-invite-title">
                    <FaUserPlus size={12} /> Invite others to your group
                </span>
                <button
                    className="group-invite-dismiss"
                    onClick={handleDismiss}
                    aria-label="Dismiss banner"
                >
                    ✕
                </button>
            </div>
            <div className="group-invite-description">
                Share this code with friends to invite them
            </div>
            <div className="group-invite-actions">
                <div className="group-invite-code-row">
                    <div className="group-invite-code-display">
                        {group.invite_code}
                    </div>
                    <button
                        onClick={copyToClipboard}
                        className={`group-invite-code-copy-btn ${copySuccess ? 'success' : ''}`}
                        title={copySuccess ? "Copied!" : "Copy to clipboard"}
                    >
                        {copySuccess ? '✓' : '📋'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GroupInviteBanner;
